(() => {
  if (window.__sgmSyncMediaWidthInit) return;
  if (document.querySelector('.gift-card-form-option')) return;
  window.__sgmSyncMediaWidthInit = true;

  const MEDIA_SELECTOR = '.product-information__media';
  const GALLERY_SELECTOR = 'media-gallery';
  const PRODUCT_ROOT_SELECTOR = '.product-information';
  const MAIN_ID = 'MainContent';
  const TARGET_CHILD_INDEX = 1;
  const INNER_TARGET_CHILD_INDEX = 1;

  const EXCLUDED_TARGET_SELECTORS = [
    '.sgm-colstrip',
    '[id*="__sgm_collection_strip_"]',
    '[class*="sgm_collection_strip"]'
  ].join(',');

  let ro = null;
  let mo = null;
  let boundMediaEl = null;
  let targetEl = null;

  let originalParent = null;
  let originalNextSibling = null;
  let originalCaptured = false;
  let originalMarker = null;

  const isMobile = () => window.innerWidth < 900;

  const rafThrottle = (fn) => {
    let raf = 0;
    return (...args) => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        fn(...args);
      });
    };
  };

  function isProductContext() {
    return !!(
      document.querySelector(PRODUCT_ROOT_SELECTOR) &&
      document.querySelector(GALLERY_SELECTOR) &&
      document.querySelector(MEDIA_SELECTOR) &&
      document.getElementById(MAIN_ID)
    );
  }

  function isExcludedTarget(el) {
    if (!el || el.nodeType !== 1) return false;
    return !!(el.matches(EXCLUDED_TARGET_SELECTORS) || el.closest(EXCLUDED_TARGET_SELECTORS));
  }

  function getMainTargetFromDom() {
    if (!isProductContext()) return null;

    const main = document.getElementById(MAIN_ID);
    if (!main) return null;

    const candidate =
      main.children && main.children.length > TARGET_CHILD_INDEX
        ? main.children[TARGET_CHILD_INDEX]
        : null;

    if (!candidate) return null;
    if (isExcludedTarget(candidate)) return null;

    return candidate;
  }

  function getGalleryEl() {
    return document.querySelector(GALLERY_SELECTOR);
  }

  function getMediaEl() {
    return document.querySelector(MEDIA_SELECTOR);
  }

  function getMoveHostEl() {
    /**
     * Importante:
     * usiamo .product-information__media e NON media-gallery.
     * media-gallery può essere rigenerato al cambio variante.
     */
    return getMediaEl() || getGalleryEl();
  }

  function getInnerGridTarget(el) {
    if (!el || !el.children || el.children.length <= INNER_TARGET_CHILD_INDEX) {
      return null;
    }

    return el.children[INNER_TARGET_CHILD_INDEX];
  }

  function clearInlineStyles(el) {
    if (!el) return;

    el.style.width = '';
    el.style.maxWidth = '';

    const innerEl = getInnerGridTarget(el);
    if (innerEl) {
      innerEl.style.gridTemplateColumns = '';
    }
  }

  function captureOriginalPosition(el) {
    if (!el || originalCaptured || isExcludedTarget(el)) return;

    originalParent = el.parentNode || null;
    originalNextSibling = el.nextSibling || null;

    if (originalParent && !originalMarker) {
      originalMarker = document.createComment('sgm-sync-original-position');
      originalParent.insertBefore(originalMarker, el);
    }

    originalCaptured = true;
    el.setAttribute('data-sgm-sync-target', 'true');
  }

  function ensureTarget() {
    /**
     * Se abbiamo già targetEl, lo teniamo anche se in questo momento
     * non è nel DOM. Può succedere quando media-gallery viene sostituito.
     */
    if (targetEl && !isExcludedTarget(targetEl)) {
      return targetEl;
    }

    if (!isProductContext()) return null;

    const marked = document.querySelector('[data-sgm-sync-target="true"]');
    if (marked && !isExcludedTarget(marked)) {
      targetEl = marked;
      captureOriginalPosition(targetEl);
      return targetEl;
    }

    const found = getMainTargetFromDom();
    if (!found) return null;

    targetEl = found;
    captureOriginalPosition(targetEl);

    return targetEl;
  }

  function applyDesktopStyles(px) {
    const el = ensureTarget();
    if (!el || !px || px <= 0) return;

    const finalWidth = px - 20;

    el.style.width = `${finalWidth}px`;
    el.style.maxWidth = `${finalWidth}px`;

    const innerEl = getInnerGridTarget(el);
    if (innerEl) {
      innerEl.style.gridTemplateColumns = '0';
    }
  }

  function applyMobileStyles() {
    const el = ensureTarget();
    if (!el) return;

    el.style.width = '100%';
    el.style.maxWidth = '100%';

    const innerEl = getInnerGridTarget(el);
    if (innerEl) {
      innerEl.style.gridTemplateColumns = '';
    }
  }

  function moveTargetToGalleryEnd() {
    const el = ensureTarget();
    const host = getMoveHostEl();

    if (!el || !host) return;
    if (isExcludedTarget(el)) return;
    if (el === host || el.contains(host)) return;

    if (el.parentNode !== host || el !== host.lastElementChild) {
      host.appendChild(el);
    }
  }

  function restoreTargetToOriginalPosition() {
    const el = targetEl;
    if (!el || isExcludedTarget(el)) return;

    /**
     * Prima scelta: marker originale.
     * Funziona anche se el è stato staccato dal DOM.
     */
    if (originalMarker && originalMarker.parentNode) {
      const parent = originalMarker.parentNode;
      const refNode = originalMarker.nextSibling;

      if (refNode !== el) {
        parent.insertBefore(el, refNode);
      }

      return;
    }

    /**
     * Fallback: vecchio parent originale.
     */
    if (originalParent && document.contains(originalParent)) {
      if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
        originalParent.insertBefore(el, originalNextSibling);
      } else if (el.parentNode !== originalParent) {
        originalParent.appendChild(el);
      }

      return;
    }

    /**
     * Ultimo fallback: MainContent.
     */
    const main = document.getElementById(MAIN_ID);
    if (!main) return;

    if (main.children.length > TARGET_CHILD_INDEX) {
      const refNode = main.children[TARGET_CHILD_INDEX];

      if (refNode !== el) {
        main.insertBefore(el, refNode);
      }
    } else {
      main.appendChild(el);
    }
  }

  function cleanupNonProductContext() {
    detachObservers();

    if (targetEl && !isExcludedTarget(targetEl)) {
      restoreTargetToOriginalPosition();
      clearInlineStyles(targetEl);
    }

    boundMediaEl = null;
  }

  const syncLayout = rafThrottle(() => {
    if (!isProductContext()) {
      cleanupNonProductContext();
      return;
    }

    const el = ensureTarget();
    if (!el) return;

    if (isMobile()) {
      restoreTargetToOriginalPosition();
      applyMobileStyles();
      return;
    }

    moveTargetToGalleryEnd();

    const media = getMediaEl();
    if (!media) return;

    const rect = media.getBoundingClientRect();
    const w = Math.round(rect.width);

    applyDesktopStyles(w);
  });

  function detachObservers() {
    if (ro) {
      try {
        ro.disconnect();
      } catch (e) {}
    }

    ro = null;
    boundMediaEl = null;
  }

  function attachResizeObserver(mediaEl) {
    detachObservers();
    if (!mediaEl) return;

    boundMediaEl = mediaEl;

    ro = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (!isProductContext()) {
          cleanupNonProductContext();
          return;
        }

        if (isMobile()) {
          restoreTargetToOriginalPosition();
          applyMobileStyles();
          return;
        }

        const w = Math.round(entry.contentRect.width);

        moveTargetToGalleryEnd();
        applyDesktopStyles(w);
      }
    });

    ro.observe(mediaEl);
  }

  function initOrRebind() {
    if (!isProductContext()) {
      cleanupNonProductContext();
      return;
    }

    const el = ensureTarget();
    const media = getMediaEl();

    if (!el || isExcludedTarget(el)) return;

    if (!originalCaptured) {
      captureOriginalPosition(el);
    }

    syncLayout();

    if (media !== boundMediaEl) {
      attachResizeObserver(media);
    }
  }

  const rebinder = rafThrottle(initOrRebind);

  const delayedRebind = () => {
    rebinder();

    window.setTimeout(() => {
      rebinder();
    }, 80);

    window.setTimeout(() => {
      rebinder();
    }, 250);
  };

  mo = new MutationObserver((mutations) => {
    const shouldRebind = mutations.some((mutation) => {
      if (mutation.target && mutation.target.nodeType === 1) {
        if (mutation.target.closest && mutation.target.closest(EXCLUDED_TARGET_SELECTORS)) {
          return false;
        }
      }

      for (const node of mutation.addedNodes || []) {
        if (node.nodeType === 1) {
          if (node.matches && node.matches(EXCLUDED_TARGET_SELECTORS)) {
            continue;
          }

          if (node.querySelector && node.querySelector(EXCLUDED_TARGET_SELECTORS)) {
            continue;
          }
        }
      }

      return true;
    });

    if (shouldRebind) {
      rebinder();
    }
  });

  mo.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.addEventListener('resize', syncLayout, { passive: true });

  /**
   * Utile quando il cambio variante aggiorna l'URL/hash
   * e subito dopo Shopify rigenera media/gallery.
   */
  window.addEventListener('hashchange', delayedRebind, { passive: true });
  window.addEventListener('popstate', delayedRebind, { passive: true });

  /**
   * Eventi comuni nei temi Shopify/custom.
   * Se non vengono emessi, non succede nulla.
   */
  document.addEventListener('variant:change', delayedRebind);
  document.addEventListener('shopify:section:load', delayedRebind);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOrRebind, { once: true });
  } else {
    initOrRebind();
  }
})();